import * as React from "react";
import type { SVGProps } from "react";
const SvgIconDropbox = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 76 75"
    {...props}
  >
    <rect
      width={75}
      height={75}
      x={0.205}
      y={-0.009}
      fill="#fff"
      rx={14}
    />
    <path
      fill="#0061FF"
      d="m24.841 32.028 12.865-8.195L24.84 15.64l-12.862 8.194z"
    />
    <path
      fill="#0061FF"
      d="m50.568 32.028 12.863-8.195-12.863-8.194-12.862 8.194zM37.706 40.223 24.84 32.028 11.98 40.223l12.862 8.195z"
    />
    <path
      fill="#0061FF"
      d="m50.568 48.418 12.863-8.195-12.863-8.195-12.862 8.195zM50.568 51.149l-12.862-8.195L24.84 51.15l12.865 8.195z"
    />
  </svg>
);
export default SvgIconDropbox;
